export const apiConstants = {
  create: 'Account/RegisterBrief',
  login: 'Account/Login',
  usernameExists: 'Account/UsernameExists?username=',
};
